import classNames from 'classnames';
import MarkdownComponent from 'markdown-to-jsx';
import { useMemo, memo } from 'react';
import { CustomLink } from '../customLink';

/**
 * markdown-to-jsx only treats `---`/`***`/`___` as a thematic break (`<hr>`) when the
 * marker sits on its own line with blank lines around it. Streamed AI responses often
 * emit the marker directly adjacent to a list/heading, where it is silently dropped (or
 * parsed as a setext heading underline). Re-pad standalone markers so they always render
 * as a divider, then collapse the extra blank lines we introduced.
 */
const normalizeThematicBreaks = content => {
  if (typeof content !== 'string') return content;
  return content.replace(/\r\n?/g, '\n').replace(/^[ \t]*(-{3,}|\*{3,}|_{3,})[ \t]*$/gm, '\n\n$&\n\n').replace(/\n{3,}/g, '\n\n');
};
export { normalizeThematicBreaks };
const headingH1Css = "h110op39";
const headingH2Css = "h1x7j6rx";
const bodyTextCss = "b1tg6u3d";
const bodyTextStrongCss = "byn74xm";
const headingH3Css = "h1vlosi0";
const markdownContainerCss = "m14hlthm";
const styledListCss = "s1o2uz8p";
const styledUnorderedListCss = "s62ndv7";
const styledOrderedListCss = "s1ayqnf3";
const styledListItemCss = "sq7s274";
const headingH3SpacingCss = "h13h2lk9";
const styledHrCss = "s1r9h7rv";
const createOverrides = analyticsHandlers => ({
  h1: {
    component: 'h1',
    props: {
      className: headingH1Css
    }
  },
  h2: {
    component: 'h2',
    props: {
      className: headingH2Css
    }
  },
  h3: {
    component: 'h3',
    props: {
      className: classNames(headingH3Css, headingH3SpacingCss)
    }
  },
  ul: {
    component: 'ul',
    props: {
      className: classNames(styledListCss, styledUnorderedListCss)
    }
  },
  ol: {
    component: 'ol',
    props: {
      className: classNames(styledListCss, styledOrderedListCss)
    }
  },
  li: {
    component: 'li',
    props: {
      className: styledListItemCss
    }
  },
  p: {
    component: 'p',
    props: {
      className: bodyTextCss
    }
  },
  strong: {
    component: 'strong',
    props: {
      className: bodyTextStrongCss
    }
  },
  span: {
    component: 'span',
    props: {
      className: bodyTextCss
    }
  },
  a: {
    component: linkProps => <CustomLink {...linkProps} analyticsHandlers={analyticsHandlers} />
  },
  hr: {
    component: 'hr',
    props: {
      className: styledHrCss
    }
  }
});
export const Markdown = memo(({
  analyticsHandlers,
  children,
  ...props
}) => {
  const overrides = useMemo(() => createOverrides(analyticsHandlers), [analyticsHandlers]);
  const normalizedChildren = useMemo(() => normalizeThematicBreaks(children), [children]);
  return <MarkdownComponent {...props} className={classNames(markdownContainerCss, props.className)} options={{
    wrapper: 'div',
    overrides
  }}>
      {normalizedChildren}
    </MarkdownComponent>;
});

require("./Markdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Markdown.js");